import * as React from 'react';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails, AccordionSummary, Grid, Rating, Typography, useTheme } from '@mui/material';

import { ReactComponent as ZonesMenuSvg } from 'assets/images/menu_zones.svg';
import { IBuildingTreeItemAction, IZoneVisualization } from 'models';
import { EnhancedAccordion } from 'components/styled-mui';
import { BuildingTreeItemHeader } from '.';

interface BuildingTreeZoneItemProps {
  zone: IZoneVisualization;
}

export const BuildingTreeZoneItem: React.FC<BuildingTreeZoneItemProps> = (props) => {
  const theme = useTheme();
  const { zone } = props;
  const [expanded, setExpanded] = React.useState<boolean>(false);
  // const [visible, setVisible] = React.useState<boolean>(true);

  const icon = <ZonesMenuSvg />;
  const title = zone.name;
  const actions: Array<IBuildingTreeItemAction> = [
    // {
    //   tooltip: visible ? 'Show zone' : 'Hide zone',
    //   icon: visible ? <VisibilityOutlined fontSize="inherit" /> : <VisibilityOffOutlined fontSize="inherit" />,
    //   onClick: () => {
    //     zone.pathShape.visible = !visible;
    //     zone.pinPathGroup.visible = !visible;
    //     setVisible(!visible);
    //   },
    // },
    // {
    //   tooltip: 'Show pin',
    //   icon: <LocationOnOutlined fontSize="inherit" />,
    //   onClick: () => {},
    // },
  ];

  return (
    <EnhancedAccordion expanded={expanded} dividerColor={`${theme.palette.primary.light}60`}>
      <AccordionSummary
        expandIcon={<ExpandMore color="primary" />}
        onClick={() => {
          setExpanded((prev) => !prev);
        }}
      >
        <BuildingTreeItemHeader icon={icon} title={title} actions={actions} paddingRight={1.5} />
      </AccordionSummary>

      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <Typography variant="body2" color="textSecondary">
              Status:
            </Typography>
          </Grid>

          <Grid item xs={7}>
            <Typography variant="body2" color="primary">
              {zone.status}
            </Typography>
          </Grid>

          <Grid item xs={5}>
            <Typography variant="body2" color="textSecondary">
              Last service:
            </Typography>
          </Grid>

          <Grid item xs={7}>
            <Typography variant="body2" color="primary">
              {zone.lastService}
            </Typography>
          </Grid>

          <Grid item xs={5}>
            <Typography variant="body2" color="textSecondary">
              Rating:
            </Typography>
          </Grid>

          <Grid item xs={7}>
            <Typography variant="body2" color="primary">
              <Rating value={zone.rating} readOnly size="small" />
            </Typography>
          </Grid>
        </Grid>
      </AccordionDetails>
    </EnhancedAccordion>
  );
};
